export const CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY = {
  "displayInFrontend": {
    sectionKey: "displayInFrontend",
    sectionContent: {
      "display_in_frontend_key": "display_in_frontend_key",
    },
  },
  "general": {
    sectionKey: "general",
    sectionContent: {
      "general_name_key": "general_name_key",
      "short_description_optional_key": "short_description_optional_key",
      "related_brand_optional_key": "related_brand_optional_key",
    },
  },
  "targetCustomers": {
    sectionKey: "targetCustomers",
    sectionContent: {
      "is_exclusive_campaign_key": "is_exclusive_campaign_key",
      "target_customer_selector_key": "target_customer_selector_key",
      "exclude_blacklist_segment_switch_key": "exclude_blacklist_segment_switch_key",
      "blacklist_segment_selector_key": "blacklist_segment_selector_key",
    },
  },
  "keyVisual": {
    sectionKey: "keyVisual",
    sectionContent: {
      "cover_photo_upload_key": "cover_photo_upload_key",
      "other_photo_upload_key": "other_photo_upload_key",
      "square_cover_photo_upload_key": "square_cover_photo_upload_key",
    },
  },
  "instruction": {
    sectionKey: "instruction",
    sectionContent: {
      "instruction_section_key": "instruction_section_key",
    },
  },
  "detail": {
    sectionKey: "detail",
    sectionContent: {
      "detail_section_key": "detail_section_key",
    },
  },
  "campaignListingSection": {
    sectionKey: "campaignListingSection",
    sectionContent: {
      "homepage_banner_key": "homepage_banner_key",
      "banner_visible_period_key": "banner_visible_period_key",
      "banner_image_key": "banner_image_key",
      "banner_display_order_key": "banner_display_order_key",
      "is_featured_campaign_key": "is_featured_campaign_key",
      "show_in_offer_tab_key": "show_in_offer_tab_key",
      "campaign_category_selector_key": "campaign_category_selector_key",
    },
  },
  "mall": {
    sectionKey: "mall",
    sectionContent: {
      "visible_mall_key": "visible_mall_key",
    },
  },
  "activePeriod": {
    sectionKey: "activePeriod",
    sectionContent: {
      "active_period_key": "active_period_key",
      "blackout_period_key": "blackout_period_key",
    },
  },
  "visiblePeriod": {
    sectionKey: "visiblePeriod",
    sectionContent: {
      "visible_period_section_key": "visible_period_section_key",
    },
  },
  "recurringCampaign": {
    sectionKey: "recurringCampaign",
    sectionContent: {
      "recurring_birthday_selector_key": "recurring_birthday_selector_key",
    },
  },
  "recurringCampaignActivePeriod": {
    sectionKey: "recurringCampaignActivePeriod",
    sectionContent: {
      "recurring_birthday_active_period_selector_key": "recurring_birthday_active_period_selector_key",
    },
  },
  "recurringCampaignVisiblePeriod": {
    sectionKey: "recurringCampaignVisiblePeriod",
    sectionContent: {
      "recurring_birthday_visible_period_selector_key": "recurring_birthday_visible_period_selector_key",
    },
  },
  "recurringMessage": {
    sectionKey: "recurringMessage",
    sectionContent: {
      "recurring_message_selector_key": "recurring_message_selector_key",
    },
  },
};

// earning
export const CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY = {
  "requirements": {
    sectionKey: "requirements",
    sectionContent: {
      // general purchase
      "per_transaction_key": "per_transaction_key",
      "eligible_days_key": "eligible_days_key",
      "upload_eligible_days_key": "upload_eligible_days_key",
      "is_exclude_delivery_cost_key": "is_exclude_delivery_cost_key",
      "is_exclude_other_charges_key": "is_exclude_other_charges_key",
      "line_item_requirement_key": "line_item_requirement_key",
      "sku_type_selector_key": "sku_type_selector_key",
      "have_eligible_stores_key": "have_eligible_stores_key",
      "store_selector_key": "store_selector_key",

      // qr code
      "qr_code_scanning_section_key": "qr_code_scanning_section_key",

      // gps check in
      "gps_latitude_key": "gps_latitude_key",
      "gps_longitude_key": "gps_longitude_key",
      "gps_radius_key": "gps_radius_key",

      // level upgrade
      "level_upgrade_section_key": "level_upgrade_section_key",

    },
  },
  "reward": {
    sectionKey: "reward",
    sectionContent: {
      "reward_logic_section_key": "reward_logic_section_key",
      "reward_amount_input_area_key": "reward_amount_input_area_key",
      "reward_quantity_key": "reward_quantity_key",
      "reward_tpe_key": "reward_tpe_key",

      // memeber referral
      "referral_type_key": "referral_type_key",
    },
  },
  "executionPriority": {
    sectionKey: "executionPriority",
    sectionContent: {
      "execution_priority_input_key": "execution_priority_input_key",
    },
  },
  "limit": {
    sectionKey: "limit",
    sectionContent: {
      "have_limits_key": "have_limits_key",
      "limits_split_line_key": "limits_split_line_key",
      "purchase_earning_rule_reward_limit_key": "purchase_earning_rule_reward_limit_key",
      "limit_section_key": "limit_section_key",

      // member referral
      "max_invitees_key": "max_invitees_key",

      // level upgrade
      "level_upgrade_per_head_periodic_limit_section_key": "level_upgrade_per_head_periodic_limit_section_key",

      // filling form
      "filling_form_section_key": "filling_form_section_key",
    },
  },
  "promotionCode": {
    sectionKey: "promotionCode",
    sectionContent: {
      "promotion_code_switch_key": "promotion_code_switch_key",
      "promotion_code_input_key": "promotion_code_input_key",
      "promotion_code_max_times_key": "promotion_code_max_times_key",
    },
  },
};

// coupon
export const COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY = {
  requirementsSection: {
    sectionKey: "requirementsSection",
    sectionContent: {
      "required_points_key": "required_points_key"
    }
  },
  limitSection: {
    sectionKey: "limitSection",
    sectionContent: {
      "show_limit_key": "show_limit_key",
      "display_overall_limit_key": "display_overall_limit_key",
      "per_head_limit_key": "per_head_limit_key",
    }
  },
}

export const BASE_COUPON_PAGE_ANCHOR_KEY = {
  couponGeneral: {
    sectionKey: "couponGeneral",
    sectionContent: {
      "general_name_key": "general_name_key",
      "short_description_optional_key": "short_description_optional_key",
    }
  },
  couponKeyVisual: {
    sectionKey: "couponKeyVisual",
    sectionContent: {
      "cover_photo_upload_key": "cover_photo_upload_key",
      "other_photo_upload_key": "other_photo_upload_key",
    }
  },
  couponInstruction: {
    sectionKey: "couponInstruction",
    sectionContent: {
      "instruction_section_key": "instruction_section_key",
    }
  },
  couponDetail: {
    sectionKey: "couponDetail",
    sectionContent: {
      "detail_section_key": "detail_section_key",
    }
  },
  validPeriod: {
    sectionKey: "validPeriod",
    sectionContent: {
      "valid_period_type_key": "valid_period_type_key",
    }
  },
  applicableStores: {
    sectionKey: "applicableStores",
    sectionContent: {
      "store_selector_key": "store_selector_key",
      "coupon_required_select_store_key": "coupon_required_select_store_key",
      "time_to_select_store_key": "time_to_select_store_key",
      "related_brand_optional_key": "related_brand_optional_key",
    }
  },
  couponProperties: {
    sectionKey: "couponProperties",
    sectionContent: {
      "coupon_properties_section_key": "coupon_properties_section_key",
    }
  },
  generateCoupons: {
    sectionKey: "generateCoupons",
    sectionContent: {
      "generate_coupons_key": "generate_coupons_key",
    }
  },
  additionalData: {
    sectionKey: "additionalData",
    sectionContent: {
      "additional_data_key": "additional_data_key",
    }
  },
}

export const CAMPAIGN_COUPON_PAGE_ANCHOR_KEY = {
  sameAsCampaignSection: {
    sectionKey: "sameAsCampaignSection",
    sectionContent: {
      "same_as_campaign_key": "same_as_campaign_key"
    }
  },
  ...BASE_COUPON_PAGE_ANCHOR_KEY,
}

export const CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY = {
  "linkedCoupon": "linkedCoupon",
  "contentPage": "contentPage",
  "earningRulePage": "earningRulePage",
  "couponPage": "couponPage",
  "checklist": "checklist",
  "detailGeneral": "detailGeneral",
};

export const DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY = {
  "generalInfo": {
    sectionKey: "general_info",
    sectionContent: {
      "campaignStatus": "campaign_status",
      "creationTime": "creation_time",
      "lastModifiedTime": "last_modified_time",
      "lastModifiedBy": "last_modified_by",
    },
  },
}

export const campaignDetailGeneralAnchorConfig = [
  {
    title: "General",
    anchorKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.detailGeneral,
    className: "",
    sublist: []
  }
];
